import React from "react";
import NewsFeedsList from "./NewsFeedsList";
import useMakeScrollable from "../../custom_hooks/make-scrollable";

const News = ({ classes }) => {
  useMakeScrollable()
  return (
    <div className="news">
       <div className="scrollable">
          <NewsFeedsList classes={classes} />
      </div>
    </div>
  );
};

export default News;
